
import { DocumentTypeDto } from '@proxy/lookup'
export interface DocumentType extends DocumentTypeDto {

}
